<template>
  <div style="width: 100%; position: fixed; overflow: hidden" light class="customscroll">
    <div :class="(isOnMobile ? 'mobilelanding ' : ' ') + (isWithSmallWidth ? 'smallwidthlanding ' : '')" align="center" justify="center" style="display: flex; height: 100%; width: 100%; position: relative; overflow-x: hidden; overflow-y: auto">
      <!-- <div @click="setLanguage('bg')">
        <country-flag style="cursor: pointer; z-index: 9999999; position: absolute; top: 10px; right: 50px" country="bg" size="normal" />
      </div>
      <div @click="setLanguage('ro')">
        <country-flag style="cursor: pointer; z-index: 9999999; position: absolute; top: 10px; right: 10px" country="ro" size="normal" />
      </div> -->
      <div align="center" justify="center" style="margin: auto auto; display: inline-flex; flex-flow: column nowrap">
        <t-background></t-background>
        <div :style="'width: ' + getContainerWidth" style="position: relative; z-index: 2; margin-left: auto; margin-right: auto; left: 0; right: 0">
          <div style="flex: 1; position: relative; background-size: cover" :style="{ 'background-image': 'url(' + WHITE + ')' }">
            <img :src="Header" width="100%" height="auto" />
            <div :style="'position: absolute; z-index: 10; margin-left: auto; margin-right: auto; left: 0; right: 0; bottom: ' + (isOnMobile ? '5%' : '15%')">
              <t-button id="login_button" :class="isWithSmallWidth ? 'smallerBtn' : 'biggerBtn'" @click="goToLogin()">
                <span>{{ TR.Login }}</span>
              </t-button>
              <!-- <v-hover v-slot="{ hover }">
                <img :src="ButtonLogin" :class="hover ? 'elevation-20' : ''" class="lndbutton" style="cursor: pointer" :style="isWithSmallWidth ? 'width: 200px;  min-width: 200px' : 'width: 300px; min-width: 300px'" @click="goToLogin()" />
              </v-hover>-->
            </div>
            <div style="position: absolute; right: 1%; top: 48%; z-index: 10" v-if="!isOnMobile">
              <v-card-text>
                <span class="lndtitle" style="color: white; white-space: pre-wrap">{{ s_Landing_EffectiveHelper + "\n" + s_Landing_ForYourBusiness }}</span>
              </v-card-text>
            </div>
            <div v-if="!isOnMobile" style="position: absolute; z-index: 10" :style="isOnMobile ? '' : 'left: 30px; top: 30px;'">
              <span class="lndtitlelarge">
                <span class="lndlogo">TREMOL</span>
                <span class="lndtrademark">®</span>
              </span>
            </div>
            <div v-if="!isOnMobile" style="position: absolute; z-index: 10" :style="isOnMobile ? '' : 'left: 200px; top: 38px; '">
              <span class="lndtitlelarge">
                <span class="lndlogoassistant">Assistant</span>
              </span>
            </div>
          </div>
          <div class="pa-4" style="flex: 1; position: relative; background-size: cover" :style="{ 'background-image': 'url(' + WHITE + ')' }">
            <span class="lndtitle" style="z-index: 10; white-space: pre-line">
              <span class="lndlogo">TREMOL</span>
              <span class="lndtrademark">®</span>
              <span class="lndlogoassistant">{{ "Assistant " }}</span>
              <span class="lndsubtitle">{{ s_Landing_CloudPlatform }}</span>
            </span>
            <p class="lndsubtitle">{{ s_Landing_ModernSolution }}</p>
            <p class="lndtitle lndbold">{{ s_Landing_KeyAdvantages }}</p>
            <v-row align="center" justify="center" style="padding-top: 20px; padding-bottom: 60px">
              <v-col cols="10" xl="4" lg="4" md="4" sm="10" xs="10" style="position: relative">
                <img :src="Card1" width="80%" style="min-width: 220px; max-width: 400px" />
                <div style="position: absolute; left: 0; right: 0; bottom: 10%; z-index: 10">
                  <div>
                    <span class="lndsubtitle2" style="color: white; white-space: pre-line">{{ TR.Landing_RealTimeAnalisys }}</span>
                    <p class="lndsubtitle2" style="color: white; white-space: pre-line">{{ "• " + s_Landing_SalesDone + "\n• " + s_Landing_MostSoldItems }}</p>
                  </div>
                </div>
              </v-col>
              <v-col cols="10" xl="4" lg="4" md="4" sm="10" xs="10" style="position: relative">
                <img :src="Card2" width="80%" style="min-width: 220px; max-width: 400px" />
                <div style="position: absolute; left: 0; right: 0; bottom: 15%; z-index: 10">
                  <p class="lndsubtitle2" style="color: white; white-space: pre-line">{{ s_Landing_Optimizing + "\n" + s_Landing_Expenses }}</p>
                </div>
              </v-col>
              <v-col cols="10" xl="4" lg="4" md="4" sm="10" xs="10" style="position: relative">
                <img :src="Card3" width="80%" style="min-width: 220px; max-width: 400px" />
                <div style="position: absolute; left: 0; right: 0; bottom: 15%; z-index: 10">
                  <p class="lndsubtitle2" style="color: white; white-space: pre-wrap">{{ s_Landing_Saving + "\n" + s_Landing_OnTime }}</p>
                </div>
              </v-col>
            </v-row>
          </div>
          <div style="flex: 1; position: relative; background-size: cover" :style="{ 'background-image': 'url(' + require('../../assets/img/landing/TREMOL_Assistant_WHITE.jpg') + ')' }">
            <img :src="Achievements" width="100%" height="auto" />
            <div :style="isOnMobile ? 'top: 10px;' : 'top: 60px;'" style="position: absolute; margin-left: auto; margin-right: auto; left: 0; right: 0; z-index: 10">
              <span :class="isOnMobile ? 'lndsubtitle2' : 'lndtitle'">
                <span :class="isOnMobile ? '' : 'lndbold'">{{ s_Landing_With + " " }}</span>
                <span class="lndlogo">TREMOL</span>
                <span class="lndtrademark">®</span>
                <span class="lndlogoassistant">{{ "Assistant " }}</span>
                <span :class="isOnMobile ? '' : 'lndbold'">{{ s_Landing_WillAchieve + ":" }}</span>
              </span>
            </div>
            <div style="position: absolute; z-index: 10" :style="isOnMobile ? (isWithSmallWidth ? 'left: 2%; top: 35px; ' : 'left: 22px; top: 55px;') : 'left: 50px; top: 140px; '">
              <p :class="isOnMobile ? 'lndsubtitle2' : 'lndsubtitle'" align="start" justify="start" :style="isOnMobile ? '' : 'line-height: 200%; '" style="white-space: pre-wrap">
                {{
                  isOnMobile
                    ? "• " + s_Landing_BetterControl + "\n•" + s_Landing_StaffControl + "\n• " + s_Landing_Tracking + "\n\t" + s_Landing_Sales
                    : "• " + s_Landing_BetterControl + "\n• " + s_Landing_Tracking + " " + s_Landing_Sales + "\n• " + s_Landing_StaffControl
                }}
              </p>
            </div>
          </div>
          <div style="flex: 1; position: relative; background-size: cover" :style="{ 'background-image': 'url(' + require('../../assets/img/landing/TREMOL_Assistant_WHITE.jpg') + ')' }">
            <div style="padding-top: 60px"></div>
            <v-row v-if="!isOnMobile">
              <v-card-text>
                <span class="lndsubtitle2">{{ s_Landing_Analyze }}</span>
              </v-card-text>
            </v-row>
            <v-row>
              <v-card-text class="title">
                <span class="lndtitle lndbold">{{ isOnMobile ? TR.Landing_SubscriptionPlans : TR.Landing_OurSubscriptionPlans }}</span>
              </v-card-text>
            </v-row>
            <v-row align="end" justify="center">
              <v-col cols="10" xl="4" lg="4" md="4" sm="10" xs="10" style="position: relative">
                <img :src="SubS" width="80%" style="min-width: 220px; max-width: 330px" />
                <div style="position: absolute; left: 0; right: 0; top: 33%; z-index: 10">
                  <p class="lndsubtitle" style="white-space: pre-wrap">{{ s_YouReceive + ":" }}</p>
                  <p class="lndsubtitle lndbold" style="white-space: pre-wrap">{{ s_MonthlyReports }}</p>
                </div>
                <div style="position: absolute; left: 0; right: 0; bottom: 30px; z-index: 10">
                  <p class="lndsubtitle" style="color: white; white-space: pre-wrap">{{ TR.PriceWithVat + "\n0.41 €\n0.80 лв." }}</p>
                </div>
              </v-col>
              <v-col cols="10" xl="4" lg="4" md="4" sm="10" xs="10" style="position: relative">
                <img :src="SubM" width="80%" style="min-width: 220px; max-width: 330px" />
                <div style="position: absolute; left: 0; right: 0; top: 33%; z-index: 10">
                  <p class="lndsubtitle" style="white-space: pre-wrap">{{ s_YouReceive + ":" }}</p>
                  <p class="lndsubtitle lndbold" style="white-space: pre-wrap">{{ s_DailyReports }}</p>
                  <p class="lndsubtitle lndbold" style="white-space: pre-wrap">{{ s_MonthlyReports }}</p>
                </div>
                <div style="position: absolute; left: 0; right: 0; bottom: 30px; z-index: 10">
                  <p class="lndsubtitle" style="color: white; white-space: pre-wrap">{{ TR.PriceWithVat + "\n0.72 €\n1.41 лв." }}</p>
                </div>
              </v-col>
              <v-col cols="10" xl="4" lg="4" md="4" sm="10" xs="10" style="position: relative">
                <img :src="SubL" width="80%" style="min-width: 220px; max-width: 330px" />
                <div style="position: absolute; left: 0; right: 0; top: 25%; z-index: 10">
                  <div style="display: inline-block">
                    <p class="lndsubtitle" style="white-space: pre-wrap">{{ s_YouReceive + ":" }}</p>
                    <p class="lndsubtitle lndbold" style="white-space: pre-wrap">{{ s_ReportsSales }}</p>
                    <p class="lndsubtitle2" align="start" style="white-space: pre-line">{{ "- " + s_ByReceipts + "\n- " + s_ByItems + "\n- " + s_ByQuantitiesPerHour + "\n- " + TR.ByPaymentTypes }}</p>
                    <p class="lndsubtitle lndbold" style="white-space: pre-wrap">{{ s_DailyReports }}</p>
                    <p class="lndsubtitle lndbold" style="white-space: pre-wrap">{{ s_MonthlyReports }}</p>
                    <p class="lndsubtitle lndbold" style="white-space: pre-wrap">{{ s_FuvasEvents }}</p>
                  </div>
                </div>
                <div style="position: absolute; left: 0; right: 0; bottom: 30px; z-index: 10">
                  <p class="lndsubtitle" style="color: white; white-space: pre-wrap">{{ TR.PriceWithVat + "\n1.23 €\n2.41 лв." }}</p>
                </div>
              </v-col>
            </v-row>
          </div>
          <div style="flex: 1; position: relative; background-size: cover" :style="{ 'background-image': 'url(' + require('../../assets/img/landing/TREMOL_Assistant_WHITE.jpg') + ')', 'padding-bottom': isOnMobile ? '30px' : '100px' }">
            <v-row>
              <v-card-text class="subtitle-1">
                <span class="lndsubtitle lndbold" style="white-space: pre-wrap"> {{ s_Landing_RegisterAndReceive + "\n" + s_Landing_DiscountForDevs }}</span>
              </v-card-text>
            </v-row>
            <div style="z-index: 10; margin-left: auto; margin-right: auto; left: 0; right: 0">
              <t-button id="register_button" :class="isWithSmallWidth ? 'smallerBtn' : 'biggerBtn'" @click="goToRegistration()">
                <span>{{ TR.Registration }}</span>
              </t-button>
              <!-- <v-hover v-slot="{ hover }">
                <img :src="ButtonRegister" class="lndbutton" :class="hover ? 'elevation-20' : ''" style="cursor: pointer; min-width: 200px" :style="isWithSmallWidth ? 'width: 200px' : 'width:300px'" @click="goToRegistration()" />
              </v-hover>-->
            </div>
          </div>
          <div style="flex: 1; display: inline-block; position: relative; background-size: cover" :style="{ 'background-image': 'url(' + require('../../assets/img/landing/TREMOL_Assistant_WHITE.jpg') + ')' }">
            <img :src="Mobile" width="100%" height="auto" />
            <div class="text-left" align="start" style="position: absolute; z-index: 10" :style="isOnMobile ? 'left: 10px; top: 10px;' : 'left: 50px; top: 50px;'">
              <span v-if="isOnMobile" class="lndtitle">
                <span class="lndlogo">TREMOL</span>
                <span class="lndtrademark">®</span>
                <span class="lndlogoassistant">Assistant Mobile</span>
              </span>
              <p v-else class="lndtitle">
                <span class="lndlogo">TREMOL</span>
                <span class="lndtrademark">®</span>
                <span class="lndlogoassistant">Assistant Mobile</span>
              </p>
              <p class="lndsubtitle lndbold">{{ isOnMobile ? s_Landing_ControlYourBusiness : s_Landing_ControlYourBusinessFromEverywhere }}</p>
              <p v-if="!isOnMobile" class="lndsubtitle2" align="start" justify="start" style="max-width: 55.5%; white-space: pre-wrap">{{ TR.Landing_MobileApp }}</p>
            </div>
          </div>
          <div style="flex: 1; position: relative" :style="{ 'background-image': 'url(' + require('../../assets/img/landing/TREMOL_Assistant_WHITE.jpg') + ')' }">
            <v-col style="padding-bottom: 50px">
              <v-row :style="isOnMobile ? '' : 'padding-bottom: 20px'">
                <v-card-text class="subtitle-1">
                  <span class="lndsubtitle lndbold" style="white-space: pre-wrap">{{ isOnMobile ? s_Landing_InstallMobile + ":" : s_Landing_MayInstall + ",\n" + s_Landing_FromStore }}</span>
                </v-card-text>
              </v-row>
              <v-row style="padding-bottom: 50px" align="center" justify="center">
                <v-hover v-slot="{ hover }">
                  <img
                    :src="ButtonPlayStore"
                    class="lndbuttonmobile"
                    @click="openWebSite('https://play.google.com/store/apps/details?id=com.tremol.tremolassistantmobile')"
                    :class="hover ? 'elevation-20' : ''"
                    style="cursor: pointer; width: 150px; max-width: 40%"
                  />
                </v-hover>
                <div :style="isOnMobile ? 'width: 10px;' : 'width: 50px;'"></div>
                <v-hover v-slot="{ hover }">
                  <img :src="ButtonAppStore" class="lndbuttonmobile" @click="openWebSite('https://apps.apple.com/us/app/apple-store/id1576691031')" :class="hover ? 'elevation-20' : ''" style="cursor: pointer; width: 150px; max-width: 40%" />
                </v-hover>
              </v-row>
            </v-col>
          </div>
          <div style="flex: 1; position: relative">
            <img :src="Footer" width="100%" height="auto" />
            <v-row justify-content="end">
              <div style="position: absolute; margin-left: auto; margin-right: auto; left: 0; right: 0; z-index: 10" :style="isOnMobile ? 'top: -20px' : 'top: 85px'">
                <span class="lndsubtitle lndbold">{{ s_Landing_ContactUs }}</span>
              </div>
              <div style="position: absolute; margin-left: auto; margin-right: auto; left: 0; right: 0" :style="isOnMobile ? 'top: 15px' : 'top: 130px'">
                <v-row align="center" justify="center">
                  <v-col v-if="!isOnMobile" cols="3"></v-col>
                  <v-col cols="12" xl="6" lg="6" md="6" sm="12" style="position: relative" align="center" justify="center">
                    <div align="center" justify="start" style="width: auto; display: inline-block">
                      <a class="lndsubtitle2" style="color: white; white-space: pre-line" href="mailto: assistant@tremol.bg">assistant@tremol.bg</a>

                      <p class="lndsubtitle2" style="color: white; white-space: pre-line">{{ isOnMobile ? TR.Landing_ContactsMobile : TR.Landing_Contacts }}</p>
                    </div>
                  </v-col>
                  <v-col v-if="!isOnMobile" cols="3"></v-col>
                </v-row>
              </div>
              <div style="position: absolute; margin-left: auto; margin-right: auto; left: 0; right: 0; z-index: 10" :style="isOnMobile ? 'bottom: 0px;' : 'bottom: 150px;'">
                <div class="lndtitle">
                  <span class="lndlogo">TREMOL</span>
                  <span class="lndtrademark">®</span>
                  <p v-if="isOnMobile" class="lndlogoassistant">Assistant</p>
                  <span v-else class="lndlogoassistant">Assistant</span>
                </div>
              </div>
            </v-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Translation from "../../js/Translation";
let TR = Translation.lang;
import router from "../../router";
// import CountryFlag from "vue-country-flag";
export default {
  components: {
    // CountryFlag,
  },
  data() {
    return {
      Translation: Translation,
      WHITE: require("../../assets/img/landing/TREMOL_Assistant_WHITE.jpg"),
      Header: require("../../assets/img/landing/TREMOL_Assistant_Header_img.jpg"),
      Achievements: require("../../assets/img/landing/Tremol_Assistant_Achievements_BGR.jpg"),
      // ButtonAppStore: require("../../assets/img/landing/Buttons/Download_on_APP_Store_BTN.svg"),
      ButtonPlayStore: require("../../assets/img/landing/Buttons/Download_on_PLAY_Store_BTN.svg"),
      //ButtonPlayStore: require("../../assets/img/landing/Buttons/google-play-badge-bg.png"),
      ButtonAppStore: require("../../assets/img/landing/Buttons/Download_on_APP_Store_BTN.svg"),
      Card1: require("../../assets/img/landing/Cards/Key_Advantage_Real_Time_Analysis.jpg"),
      Card2: require("../../assets/img/landing/Cards/Key_Advantage_Expenses_Optimization.jpg"),
      Card3: require("../../assets/img/landing/Cards/Key_Advantage_Time_Saving.jpg"),
      SubS: require("../../assets/img/landing/Cards/Subscription_Plan_S_bgr.png"),
      SubM: require("../../assets/img/landing/Cards/Subscription_Plan_M_bgr.png"),
      SubL: require("../../assets/img/landing/Cards/Subscription_Plan_L_bgr.png"),
      Mobile: require("../../assets/img/landing/Tremol_Assistant_Mobile_BGR.jpg"),
      Footer: require("../../assets/img/landing/TREMOL_Assistant_Footer_img.jpg"),
      TR: TR,
      s_Landing_ContactUs: TR.Landing_ContactUs,
      s_Landing_FromStore: TR.Landing_FromStore,
      s_Landing_MayInstall: TR.Landing_MayInstall,
      s_Landing_InstallMobile: TR.Landing_InstallMobile,
      s_Landing_ControlYourBusinessFromEverywhere: TR.Landing_ControlYourBusinessFromEverywhere,
      s_Landing_ControlYourBusiness: TR.Landing_ControlYourBusiness,
      s_Landing_DiscountForDevs: TR.Landing_DiscountForDevs,
      s_Landing_RegisterAndReceive: TR.Landing_RegisterAndReceive,
      s_ReportsSales: TR.ReportsSales,
      s_FuvasEvents: TR.FuvasEvents,
      s_MonthlyReports: TR.MonthlyReports,
      s_DailyReports: TR.DailyReports,
      s_YouReceive: TR.YouReceive,
      s_ByQuantitiesPerHour: TR.ByQuantitiesPerHour,
      s_ByItems: TR.ByItems,
      s_ByReceipts: TR.ByReceipts,
      s_Landing_Analyze: TR.Landing_Analyze,
      s_Landing_Sales: TR.Landing_Sales,
      s_Landing_Tracking: TR.Landing_Tracking,
      s_Landing_StaffControl: TR.Landing_StaffControl,
      s_Landing_BetterControl: TR.Landing_BetterControl,
      s_Landing_WillAchieve: TR.Landing_WillAchieve,
      s_Landing_With: TR.Landing_With,
      s_Landing_OnTime: TR.Landing_OnTime,
      s_Landing_Saving: TR.Landing_Saving,
      s_Landing_Expenses: TR.Landing_Expenses,
      s_Landing_Optimizing: TR.Landing_Optimizing,
      s_Landing_SalesDone: TR.Landing_SalesDone,
      s_Landing_MostSoldItems: TR.Landing_MostSoldItems,
      s_Landing_ModernSolution: TR.Landing_ModernSolution,
      s_Landing_CloudPlatform: TR.Landing_CloudPlatform,
      s_Landing_EffectiveHelper: TR.Landing_EffectiveHelper,
      s_Landing_ForYourBusiness: TR.Landing_ForYourBusiness,
      s_Landing_KeyAdvantages: TR.Landing_KeyAdvantages,
    };
  },
  methods: {
    setLanguage(lang) {
      this.setLang(lang);
    },
    goToLogin() {
      router.push({ path: "/login" }).catch(() => {});
    },
    goToRegistration() {
      router.push({ path: "/signup" }).catch(() => {});
    },
  },
  computed: {
    getContainerWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "lg":
        case "xl":
          return "90%";
        case "md":
        case "sm":
        case "xs":
        default:
          return "100%";
      }
    },
    isWithSmallWidth() {
      return this.wWidth <= 500;
    },
  },
  created() {
    //this.booleans.isLoading = true;
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        //setTimeout(() => {
        this.$nextTick(() => {
          this.booleans.isLoading = false;
        });
        //}, 10000);
      }
    };
    //navigator.storage.persist().then(function(persistent) { console.log(persistent)})
  },
};
</script>
<style>
@font-face {
  font-family: "Futura+XBlk+BT";
  src: local("Futura+XBlk+BT"), url(../../assets/fonts/Futuraxk.ttf);
}

@font-face {
  font-family: "Futura+XBlkIt+BT";
  src: local("Futura+XBlkIt+BT"), url(../../assets/fonts/TT0149M_.TTF);
}

/* @font-face {
  font-family: "Futura+Condensed+Plain:001.004";
  src: local("Futura+Condensed+Plain:001.004"), url(../../assets/fonts/FuturaCondensedPlain.ttf);
} */

@font-face {
  font-family: "Roboto+Condensed";
  src: local("Roboto+Condensed"), url(../../assets/fonts/RobotoCondensed-Regular.ttf);
}

@font-face {
  font-family: "Roboto";
  src: local("Roboto"), url(../../assets/fonts/Roboto-Regular.ttf);
}

.lndlogo {
  /* font-family: "Futura+XBlk+BT"; */
  font-family: "Futura+XBlkIt+BT";
  font-weight: bold;
}

.lndtrademark {
  vertical-align: top;
}

.lndtitlelarge {
  font-family: "Roboto";
  color: rgb(0, 46, 110);
  font-size: 36px;
}

.lndtitle {
  font-family: "Roboto";
  color: rgb(0, 46, 110);
  font-size: 28px;
}

.lndsubtitle {
  font-family: "Roboto+Condensed";
  color: rgb(0, 46, 110);
  font-size: 24px;
}

.lndsubtitle2 {
  font-family: "Roboto+Condensed";
  color: rgb(0, 46, 110);
  font-size: 20px;
}

.lndtitlelarge .lndtrademark {
  font-size: 20px;
  line-height: 40px;
}

.lndtitle .lndtrademark {
  font-size: 20px;
  line-height: 35px;
}

.lndsubtitle .lndtrademark {
  font-size: 15px;
  line-height: 15px;
}

.lndsubtitle2 .lndtrademark {
  font-size: 15px;
  line-height: 15px;
}

.mobilelanding .lndtitlelarge .lndtrademark {
  font-size: 26px;
  line-height: 40px;
}
.mobilelanding .lndtitle .lndtrademark {
  font-size: 22px;
  line-height: 40px;
}
.mobilelanding .lndsubtitle .lndtrademark {
  font-size: 20px;
  line-height: 35px;
}
.mobilelanding .lndsubtitle2 .lndtrademark {
  font-size: 18px;
  line-height: 30px;
}

.mobilelanding.smallwidthlanding .lndtitlelarge .lndtrademark {
  font-size: 20px;
  line-height: 40px;
}
.mobilelanding.smallwidthlanding .lndtitle .lndtrademark {
  font-size: 16px;
  line-height: 25px;
}
.mobilelanding.smallwidthlanding .lndsubtitle .lndtrademark {
  font-size: 14px;
  line-height: 22px;
}
.mobilelanding.smallwidthlanding .lndsubtitle2 .lndtrademark {
  font-size: 14px;
  line-height: 20px;
}

.mobilelanding .lndtitle {
  font-size: 36px;
}
.mobilelanding .lndsubtitle {
  font-size: 32px;
}
.mobilelanding .lndsubtitle2 {
  font-size: 28px;
}

.mobilelanding.smallwidthlanding .lndtitle {
  font-size: 20px;
}
.mobilelanding.smallwidthlanding .lndsubtitle {
  font-size: 18px;
}
.mobilelanding.smallwidthlanding .lndsubtitle2 {
  font-size: 16px;
}

.lndlogoassistant {
  font-family: "Century Gothic", CenturyGothic, AppleGothic, sans-serif;
  font-style: italic;
  color: #f97b34;
}

.lndbold {
  font-weight: bold;
}

.lndbutton {
  -webkit-border-radius: 34px 0px 34px 0px;
  -moz-border-radius: 34px 0px 34px 0px;
  border-radius: 34px 0px 34px 0px;
}

.smallwidthlanding .lndbutton {
  -webkit-border-radius: 22px 0px 22px 0px;
  -moz-border-radius: 22px 0px 22px 0px;
  border-radius: 22px 0px 22px 0px;
}

.lndbuttonmobile {
  -webkit-border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
}

/* .lndbutton:hover {
 box-shadow: -0px 0px 2px 2px rgb(0, 46, 110); 

 -webkit-transform: scale(1.05);
  -ms-transform: scale(1.05);
  transform: scale(1.05); 

 animation: bounce 1s;
} */

@keyframes bounce {
  0%,
  20%,
  60%,
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }

  40% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-10px);
  }

  80% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-5px);
  }
}
input[type="button"] {
  outline: none !important;
}
input[type="button"]::-moz-focus-inner {
  border: 0 !important;
}
*:focus {
  outline: 0 !important;
}

#login_button.smallerBtn,
#register_button.smallerBtn {
  width: 200px !important;
  min-width: 200px !important;
  height: 50px !important;
  min-height: 50px !important;
}
#register_button.biggerBtn,
#login_button.biggerBtn {
  width: 300px !important;
  min-width: 300px !important;
  height: 50px !important;
  min-height: 50px !important;
}

#login_button {
  text-decoration: none !important;
  box-shadow: inset #ffffff 0px 5px 8px -1px, #d6d6d6 1px 3px 4px !important;
  text-indent: 0px !important;
  line-height: 0px !important;
  border-radius: 40px 0 40px 0 !important;
  text-align: center !important;
  vertical-align: middle !important;
  display: inline-block !important;
  font-size: 20px !important;
  color: #002e6e !important;
  padding: 13px !important;
  border: 2px solid #002e6e !important;
  font-family: "Roboto" !important;
}

#login_button:active {
  box-shadow: inset #ffffff 0px 5px 8px -1px, #d6d6d6 1px 0 4px !important;
}

#login_button:active > span {
  display: flex !important;
  align-self: center;
  top: 0;
  vertical-align: middle;
  transition: 0s;
}

#login_button > span {
  cursor: pointer !important;
  display: inline-block !important;
  position: relative !important;
  transition: 0.5s !important;
}
#login_button:active > span:after,
#login_button > span:after {
  content: "\00bb" !important;
  position: absolute !important;
  opacity: 0 !important;
  top: 0 !important;
  right: -20px !important;
  transition: 0.5s !important;
}

#login_button:hover > span {
  padding-right: 20px !important;
}

#login_button:hover > span:after {
  opacity: 1 !important;
  right: 0 !important;
}

#register_button {
  outline: none !important;
  text-decoration: none !important;
  text-indent: 0px !important;
  line-height: 0px !important;
  border-radius: 40px 0 40px 0 !important;
  text-align: center !important;
  vertical-align: middle !important;
  display: inline-block !important;
  font-size: 20px !important;
  color: #fff !important;
  background-color: #002e6e !important;
  padding: 13px !important;
  border: 2px solid #002e6e !important;
  font-family: "Roboto" !important;
}

/* .register_button:active {
	box-shadow:inset #ffffff 0px 5px 8px -1px,#d6d6d6 1px 0 4px;
} */

#register_button > span {
  cursor: pointer !important;
  display: inline-block !important;
  position: relative !important;
  transition: 0.5s !important;
}

#register_button > span:after {
  content: "\00bb" !important;
  position: absolute !important;
  opacity: 0 !important;
  top: 0 !important;
  right: -20px !important;
  transition: 0.5s !important;
}

#register_button:hover > span {
  padding-right: 25px !important;
}
#register_button:hover > span:after {
  opacity: 1 !important;
  right: 0 !important;
}
</style>